// extracted by mini-css-extract-plugin
export default {"root":"YO572Z","catalogSelect":"qSnxuT","form":"zNCCU2","inputHolder":"i2LSBp","input":"lsZsBN","button":"_9k26a","icon":"t9wA7M","suggests":"JnDj8P"};